export const appVersion = "5.18.0"; /* x-release-please-version */
